import { ServicingCommonModel } from '@common/interfaces/servicing-common';

/**
 * ServicingCommon model details
 */
export interface ServicingCommonStateDetails {}

/**
 * ServicingCommon store state
 */
export interface ServicingCommonState extends ServicingCommonStateDetails {
  model: ServicingCommonModel | null;
}

/**
 * Name of the ServicingCommon Store
 */
export const SERVICING_COMMON_STORE_NAME = 'servicingCommon';

/**
 * ServicingCommon Store Interface
 */
export interface ServicingCommonStore {
  /** ServicingCommon state */
  [SERVICING_COMMON_STORE_NAME]: ServicingCommonState;
}
